var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFrameAll(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.66666 5C1.84 5.17333 1.89333 5.42 1.83333 5.65333C1.6 6.56 1.59333 7.56666 1.9 8.57333C2.48666 10.5133 4.19333 11.9733 6.19333 12.2733C9.87333 12.8133 12.9867 9.56666 12.2133 5.86C11.78 3.77333 10.06 2.12 7.96666 1.75333C7.15999 1.61333 6.37999 1.65333 5.65999 1.84C5.42666 1.9 5.17333 1.84 5.00666 1.67333C4.63333 1.3 4.81999 0.679996 5.31999 0.546663C6.29999 0.29333 7.35999 0.25333 8.45333 0.486663C11.1067 1.06 13.18 3.27333 13.5867 5.95333C14.28 10.4933 10.3733 14.34 5.82666 13.5667C3.15333 13.1067 0.986662 10.9933 0.466662 8.33333C0.259995 7.27333 0.306662 6.25333 0.546662 5.31333C0.679995 4.81333 1.3 4.63333 1.66666 5ZM2.99999 7C2.99999 4.79333 4.79333 3 6.99999 3C9.20666 3 11 4.79333 11 7C11 9.20666 9.20666 11 6.99999 11C4.79333 11 2.99999 9.20666 2.99999 7ZM3.66666 2.66666C3.66666 3.22 3.22 3.66666 2.66666 3.66666C2.11333 3.66666 1.66666 3.22 1.66666 2.66666C1.66666 2.11333 2.11333 1.66666 2.66666 1.66666C3.22 1.66666 3.66666 2.11333 3.66666 2.66666Z",
    fill: "white",
    fillOpacity: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrameAll);
export default __webpack_public_path__ + "static/media/frame_all.409e6ef0b0b6cf37268ddf196ce67a5f.svg";
export { ForwardRef as ReactComponent };